<template>
    <q-inner-loading :showing="show">
        <q-spinner class="loader" color="primary" size="3em" :thickness="10" />
        <p v-text="text"></p>
        <q-btn
            v-if="showCancelButton"
            @click="$emit('cancel')"
            :label="$t('Cancel')"
            class="downloadButtonBackground ellipsis"
            text-color="primary"
            color="white"
            outline
        />
    </q-inner-loading>
</template>

<script>
export default {
    name: 'Loader',
    emits: ['cancel'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        showCancelButton: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style>
.loader {
    margin-bottom: 10px;
}
</style>
